/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_widgetgenerator.js                                                                   */
/**********************************************************************************************************************/
/* Controller.Custom */
HafasWidgetGenerator.prototype.Controller = {};
HafasWidgetGenerator.prototype.Controller.WidgetGenerator = {
  data: {
    tp: {},
    sq: {}
  },
  gui: {
    selectboxes: []
  },
  index: function () {
    Hafas.bind(this.Controller.WidgetGenerator.generatorDimensionChanged, this)();
    var templates = [
      "common.html",
      'common.new.html',
      'common.content.html',
      'common.actionbar.html',
      'common.buttons.html',
      'common.icons.html',
      'common.product.html',
      'common.input_datetime.html',
      'common.input_selectbox.html',
      'common.segmentedControl.html',
      'common.input.html',
      'common.options.html',
      'common.loading.html'
    ];
    Hafas.Modules.History.addData("WidgetGenerator", "changePage", {pageId: "Settings"});
    Hafas.Modules.Loader.loadTemplateFiles(templates, Hafas.bind(function () {
      Hafas.Modules.Render.render({
          file: 'widgetgenerator.index.html',
          target: Hafas('#' + this.formContainer, false),
          template: 'Widgetgenerator_TplIndex',
          model: {}
        }, Hafas.bind(function () {
          // Hauptnavigation initialisieren
          this.Controller.WidgetGenerator.mainNavi = Hafas.Core.newType('HafasSegmentedControl', {
            holder: 'HFS_Widgetgenerator_Navi',
            callback: Hafas.bind(function (data) {
            }, this)
          });
          this.Controller.WidgetGenerator.mainNavi.initiate();

          // Load initial page 'Settings'
          Hafas.bind(this.Controller.WidgetGenerator.changePage, this)('Settings');

          Hafas.bind(this.Controller.WidgetGenerator.prepareWidgetCode, this)();

        }, this)
      );
    }, this));
  },
  initSettings: function () {
    // Initialize select boxes
    // Language
    var selectBoxLanguage = Hafas.Core.newType('HafasSelectBox', {
      holder: 'HFS_WidgetgeneratorLanguageSelect_Holder', callback: Hafas.bind(function (data) {
        this.Controller.WidgetGenerator.settings.lang = data.value;
        Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
      }, this)
    });
    selectBoxLanguage.initiate();
    this.Controller.WidgetGenerator.gui.selectboxes.push(selectBoxLanguage);
    // Color scheme
    if (Hafas('#HFS_WidgetgeneratorColorSchemeSelect')) {
      var selectBoxColorScheme = Hafas.Core.newType('HafasSelectBox', {
        holder: 'HFS_WidgetgeneratorColorSchemeSelect_Holder', callback: Hafas.bind(function (data) {
          this.Controller.WidgetGenerator.settings.colorScheme = data.value;
          Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
        }, this)
      });
      selectBoxColorScheme.initiate();
      this.Controller.WidgetGenerator.settings.colorScheme = selectBoxColorScheme.getState().value
      this.Controller.WidgetGenerator.gui.selectboxes.push(selectBoxColorScheme);
    }
  },
  initEmbed: function () {
    // Iterieren über alle Widget Typen:
    var widgetTypes = this.Controller.WidgetGenerator.activeWidgets[0].widgetTypes;
    for (var w = 0; w < widgetTypes.length; w++) {
      if (widgetTypes[w].layout == 'button' && typeof widgetTypes[w].useTextInput != 'undefined' && widgetTypes[w].useTextInput) {

        Hafas('#HFS_WidgetgeneratorButtonTextInput_' + widgetTypes[w].id, false).onfocus = function (meCtx, embedId) {
          var widgetGenController = meCtx.Controller.WidgetGenerator;
          return function () {
            Hafas('#HFS_WidgetgeneratorEmbedOption_' + embedId, false).checked = true;
            Hafas('#HFS_WidgetgeneratorEmbedOption_' + embedId, false).onclick();
          }
        }(this, widgetTypes[w].id);

        Hafas('#HFS_WidgetgeneratorButtonTextInput_' + widgetTypes[w].id, false).onkeyup = function (meCtx, embedId) {
          var widgetGenController = meCtx.Controller.WidgetGenerator;
          return function () {
            Hafas.bind(widgetGenController.updateButtonText, meCtx)(embedId, this.value)
          }
        }(this, widgetTypes[w].id);
      }
    }
  },
  initTP: function () {
    // setting tdp-configuration
    var current = {};
    if (typeof this.Controller.WidgetGenerator.settings.features.TP.data.date != 'undefined') {
      current.date = this.Controller.WidgetGenerator.settings.features.TP.data.date;
    }
    if (typeof this.Controller.WidgetGenerator.settings.features.TP.data.time != 'undefined') {
      current.time = this.Controller.WidgetGenerator.settings.features.TP.data.time;
    }
    if (typeof this.Controller.WidgetGenerator.settings.features.TP.data.enquiry != 'undefined') {
      current.enquiry = this.Controller.WidgetGenerator.settings.features.TP.data.enquiry;
    }
    if (typeof this.Controller.WidgetGenerator.settings.features.TP.data.nowMode != 'undefined') {
      current.nowMode = this.Controller.WidgetGenerator.settings.features.TP.data.nowMode;
    }
    var dateTimePickerConfig = {
      holder: "HFS_WidgetgeneratorTpDateTimePickerHolder",
      id: "WidgetgeneratorOutDTP",
      config: {},
      current: current
    };

    this.Controller.WidgetGenerator.settings.features.TP.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);
    var inputFields = ["From", "To"];
    for (var i = 0; i < inputFields.length; i++) {
      this.Controller.WidgetGenerator.settings.features.TP["inp" + inputFields[i]] = Hafas.Core.newType('hafasSuggest', {
        loc: "HFS_WidgetgeneratorTPInput" + inputFields[i],
        type: "S",
        onSelect: function (loc) {

        },
        onClear: function () {
        }
      });
    }

    // Initiale Einstellung "Sofort suchen" ermitteln und setzen
    if (typeof Hafas('#HFS_WidgetGenToggleAutoSearch_TP') != 'undefined') {
      Hafas.bind(this.Controller.WidgetGenerator.toggleAutoSearch, this)(Hafas('#HFS_WidgetGenToggleAutoSearch_TP').checked, 'TP');
    }
  },
  initSQ: function () {
    var current = {};
    if (typeof this.Controller.WidgetGenerator.settings.features.SQ.data.date != 'undefined') {
      current.date = this.Controller.WidgetGenerator.settings.features.TP.data.date;
    }
    if (typeof this.Controller.WidgetGenerator.settings.features.SQ.data.time != 'undefined') {
      current.time = this.Controller.WidgetGenerator.settings.features.SQ.data.time;
    }
    if (typeof this.Controller.WidgetGenerator.settings.features.SQ.data.nowMode != 'undefined') {
      current.isNowMode = this.Controller.WidgetGenerator.settings.features.SQ.data.nowMode;
    }
    var dateTimePickerConfig = {
      holder: "HFS_WidgetgeneratorSqDateTimePickerHolder",
      id: "WidgetgeneratorSqDTP",
      config: {
        useDepArrSwitch: false
      },
      current: current
    };
    this.Controller.WidgetGenerator.settings.features.SQ.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);

    var sqSuggestConfig = {};
    if (Hafas.Config.SQ.allType) {
      sqSuggestConfig.suggestType = 'ALL';
    } else {
      sqSuggestConfig.suggestType = 'S';
    }
    this.Controller.WidgetGenerator.settings.features.SQ["inpLocation"] = Hafas.Core.newType('hafasSuggest', {
      loc: "HFS_WidgetgeneratorSQInputLocation",
      config: sqSuggestConfig,
      type: "S",
      onSelect: function (loc) {

      },
      onClear: function () {
      }
    });

    // Initiale Einstellung "Sofort suchen" ermitteln und setzen
    if (Hafas('#HFS_WidgetGenToggleAutoSearch_SQ')) {
      Hafas.bind(this.Controller.WidgetGenerator.toggleAutoSearch, this)(Hafas('#HFS_WidgetGenToggleAutoSearch_SQ').checked, 'SQ');
    }
  },
  initCode: function () {
    this.Controller.WidgetGenerator.calculateCodePreviewHeight();
  },
  getActiveWidgets: function () {
    var activeWidgets = [];
    for (var w in this.Controller.WidgetGenerator.settings.features) {
      if (this.Controller.WidgetGenerator.settings.features[w].active) {
        var activeWidget = this.Controller.WidgetGenerator.settings.features[w];
        activeWidget.id = w;
        activeWidgets.push(activeWidget);
      }
    }
    return activeWidgets;
  },
  updateButtonText: function (embedId, text) {
    var controller = this.Controller.WidgetGenerator;
    for (var f in controller.settings.features) {
      var currFeature = controller.settings.features[f];
      for (var w = 0; w < currFeature.widgetTypes.length; w++) {

        // Iterate through all widget types and find the corresponding one
        if (currFeature.widgetTypes[w].id == embedId) {
          currFeature.widgetTypes[w].buttonText = Hafas.Util.HTMLDecode(text);

          // Decode input text in order to make sure no HTML code can be injected
          var textToUse = Hafas.Util.HTMLDecode(text);

          // If there is no custom input text entered, fall back on a default text
          if (text.length == 0) {
            textToUse = Hafas.Modules.i18n.get(currFeature.widgetTypes[w].defaultText);
          }

          // Prepare render model for rendering the actual button / link
          var renderModel = {
            interactive: false,
            primaryClr: Hafas.Config.Styling.ColorSchemes[Hafas.Core.getColorScheme()]['lyr-primary'],
            buttonText: textToUse,
            buttonLink: ""
          };

          // Assign new widget code to the preview HTML area
          Hafas('#HFS_WidgetgeneratorPreview_' + embedId, false).innerHTML = Hafas.Modules.Render.renderTemplate(controller.settings.buttonTpl, renderModel);

          // Update the widget preview window
          Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
        }
      }
    }
  },
  getCurrentLayoutById: function (embedId) {
    var controller = this.Controller.WidgetGenerator;
    for (var f in controller.settings.features) {
      var currFeature = controller.settings.features[f];
      for (var w = 0; w < currFeature.widgetTypes.length; w++) {
        if (currFeature.widgetTypes[w].id == embedId) {
          return currFeature.widgetTypes[w];
        }
      }
    }
  },
  updateActiveWidgets: function () {
    var numberOfActiveWidgets = Hafas.bind(this.Controller.WidgetGenerator.getActiveWidgets, this)();
    this.Controller.WidgetGenerator.activeWidgets = numberOfActiveWidgets;
  },
  changePage: function (pageId) {
    if (Hafas.Util.gui.isDisabled(Hafas('#HFS_Widgetgenerator' + pageId + 'TabBtn'))) return;
    var targetId = '#HFS_Widgetgenerator' + pageId;
    var tplId = 'Widgetgenerator_Page' + pageId;
    var currentPageId = Hafas('#HFS_Widgetgenerator', false).getAttribute("data-pageid");
    this.Controller.WidgetGenerator.currentTab = pageId;

    // Benutzer ist bereits auf der Seite, nichts tun
    if (currentPageId == pageId) {
      return;
    }
    Hafas.bind(this.Controller.WidgetGenerator.updateActiveWidgets, this)();


    Hafas.Modules.Render.render({
      file: 'widgetgenerator.index.html',
      target: Hafas(targetId, false),
      template: tplId,
      model: this.Controller.WidgetGenerator
    }, Hafas.bind(function (callbackData) {
      Hafas.bind(this.Controller.WidgetGenerator.updatePagination, this)();
      if (typeof this.Controller.WidgetGenerator["init" + pageId] == 'function') {
        Hafas.bind(this.Controller.WidgetGenerator["init" + pageId], this)();
      }
      // Preview wird getoggelt
      if (pageId == 'Embed' || pageId == 'Code') {
        Hafas.Util.gui.setVisibility(Hafas('#HFS_Widgetgenerator_Preview', false), false);
      } else {
        Hafas.Util.gui.setVisibility(Hafas('#HFS_Widgetgenerator_Preview', false), true);
      }
      Hafas('#HFS_Widgetgenerator', false).setAttribute("data-pageid", pageId);
      Hafas.Modules.History.addData("WidgetGenerator", "changePage", {pageId: pageId});
    }, this));
  },
  updatePagination: function () {
    var numberOfActiveWidgets = Hafas.bind(this.Controller.WidgetGenerator.getActiveWidgets, this)();
    if (numberOfActiveWidgets == 0) {
      Hafas('#HFS_WidgetgeneratorCodeTabBtn', false).setAttribute('aria-disabled',  true);
      Hafas.Util.gui.setVisibility(Hafas('#HFS_WidgetgeneratorNextStepBtn', false), false);
      Hafas.Util.gui.setVisibility(Hafas('#HFS_WidgetgeneratorCreateCodeBtn', false), false);
    } else {
      Hafas('#HFS_WidgetgeneratorCodeTabBtn', false).removeAttribute('aria-disabled');
      Hafas.Util.gui.setVisibility(Hafas('#HFS_WidgetgeneratorNextStepBtn', false), true);
      Hafas.Util.gui.setVisibility(Hafas('#HFS_WidgetgeneratorCreateCodeBtn', false), true);
    }
  },
  nextStep: function () {
    var naviState = this.Controller.WidgetGenerator.mainNavi.getState();
    var activeIdx = naviState.activeIndex;
    // Prüfen, ob es noch einen nächsten Schritt gibt
    if (typeof naviState.buttons[activeIdx + 1] != 'undefined') {
      for (var a = activeIdx + 1; a < naviState.buttons.length; a++) {
        if (!Hafas.Util.gui.isDisabled(naviState.buttons[a])) {
          this.Controller.WidgetGenerator.mainNavi.setActiveIndex(a);
          naviState.buttons[a].onclick();
          break;
        }
      }
    }
  },
  prevStep: function () {
    var naviState = this.Controller.WidgetGenerator.mainNavi.getState();
    var activeIdx = naviState.activeIndex;
    // Prüfen, ob es noch einen nächsten Schritt gibt
    if (typeof naviState.buttons[activeIdx - 1] != 'undefined') {
      for (var a = activeIdx - 1; a >= 0; a--) {
        if (!Hafas.Util.gui.isDisabled(naviState.buttons[a])) {
          this.Controller.WidgetGenerator.mainNavi.setActiveIndex(a);
          naviState.buttons[a].onclick();
          break;
        }
      }
    }
  },
  toggleFeature: function (featureId, boolval) {
    var features = this.Controller.WidgetGenerator.settings.features;
    features[featureId].active = boolval;
    Hafas('#HFS_Widgetgenerator' + featureId + 'TabBtn', false).setAttribute('aria-disabled', !boolval);
    Hafas.bind(this.Controller.WidgetGenerator.updateActiveWidgets, this)();
    Hafas.bind(this.Controller.WidgetGenerator.updatePagination, this)();
    if (this.Controller.WidgetGenerator.activeWidgets.length != 1) {
      this.Controller.WidgetGenerator.settings.layout = "widget";
      Hafas('#HFS_WidgetgeneratorEmbedTabBtn', false).setAttribute('aria-disabled',  true);
    } else {
      Hafas('#HFS_WidgetgeneratorEmbedTabBtn', false).removeAttribute('aria-disabled');
    }
    if (this.Controller.WidgetGenerator.activeWidgets.length > 1) {
      for (var w in this.Controller.WidgetGenerator.settings.features) {
        var tmpFeature = this.Controller.WidgetGenerator.settings.features[w];
        if (typeof tmpFeature.data.displaymode != 'undefined') {
          tmpFeature.data.displaymode = "query";
        }
      }
    }
    Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
  },
  chooseEmbedOption: function (embedId) {
    if (Hafas('#HFS_WidgetgeneratorEmbedOption_' + embedId, false)) {
      Hafas('#HFS_WidgetgeneratorEmbedOption_' + embedId, false).checked = true;
      Hafas('#HFS_WidgetgeneratorEmbedOption_' + embedId, false).onclick();
    }
  },
  selectLayout: function (data) {
    this.Controller.WidgetGenerator.settings.embedId = data.embedId;
    this.Controller.WidgetGenerator.settings.layout = data.layout;
    this.Controller.WidgetGenerator.settings.buttonTpl = data.tpl;
    if (typeof data.displayMode != 'undefined') {
      if (data.displayMode == 'results') {
        delete this.Controller.WidgetGenerator.settings.features[data.id].data.autosearch;
        delete this.Controller.WidgetGenerator.settings.features[data.id].data.postform;
      }
      this.Controller.WidgetGenerator.settings.features[data.id].data.displaymode = data.displayMode;
      this.Controller.WidgetGenerator.displayMode = data.displayMode;
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)(true);
    } else {
      if (typeof this.Controller.WidgetGenerator.displayMode != 'undefined') {
        delete this.Controller.WidgetGenerator.displayMode;
      }
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)(false);
    }
  },
  prepareButtonCode: function (customData) {
    var currentSelection = Hafas.bind(this.Controller.WidgetGenerator.getCurrentLayoutById, this)(this.Controller.WidgetGenerator.settings.embedId);
    var buttonText = '';
    if (typeof currentSelection.buttonText != 'undefined') {
      buttonText = currentSelection.buttonText;
    } else if (typeof currentSelection.defaultText != 'undefined') {
      buttonText = Hafas.Modules.i18n.get(currentSelection.defaultText);
    }

    // Build Button link:
    var features = this.Controller.WidgetGenerator.settings.features;
    if (typeof Hafas.Config.Services.widgetTargetUrl !== "undefined") {
      var targetUrl = Hafas.Config.Services.widgetTargetUrl;
      var targetUrlLanguage = (this.Controller.WidgetGenerator.settings.lang != null && Hafas.Util.types.isObject(targetUrl) && typeof targetUrl[this.Controller.WidgetGenerator.settings.lang] != 'undefined') ? this.Controller.WidgetGenerator.settings.lang : Hafas.Config.currLangObj.lang;
      var baseUrl = (Hafas.Util.types.isObject(targetUrl)) ?  targetUrl[targetUrlLanguage] : targetUrl;
    } else {
      var baseUrl = Hafas.Config.webappBasePath;
    }
    baseUrl = baseUrl + '?';
    var buttonUrl = baseUrl;
    var parameterWhiteListMapping = {
      "dep": "S",
      "arr": "Z"
    };
    var target = '';
    for (var w in features) {
      if (features[w].active) {
        var tmpType = w.toLowerCase();
        var tmpData = features[w].data;
        for (var d in tmpData) {
          if (typeof parameterWhiteListMapping[d] != 'undefined') {
            var mappedParam = parameterWhiteListMapping[d];
            buttonUrl += mappedParam + "=" + tmpData[d] + "&";
          }
          if (d == "postform" && tmpData[d] == 'newtab') {
            target = 'target="_blank"'
          }
          if (d == 'date') {
            buttonUrl += d + "=" + Hafas.Util.date.hciDate2string(tmpData[d]) + "&"
          }
          if (d == 'time') {
            buttonUrl += d + "=" + Hafas.Util.date.hciTime2string(tmpData[d]) + "&"
          }
          if (d == 'enquiry') {
            var timeSelValue = (tmpData[d] == false) ? "arrive" : "depart";
            buttonUrl += "timeSel=" + timeSelValue + "&"
          }
          if (d == 'autosearch' && tmpData[d] == true) {
            buttonUrl += "start=yes&";
          }
        }
      }
    }
    if (this.Controller.WidgetGenerator.settings.lang != null) {
      buttonUrl += "language=" + this.Controller.WidgetGenerator.settings.lang + "&";
    }
    // if virtual client is set, use the param for buttonUrl
    if (Hafas.Config.CustomerName != null) {
      buttonUrl += "L=" + Hafas.Config.CustomerName + "&";
    }

    Hafas.Modules.Render.render({
      file: 'widgetgenerator.index.html',
      template: this.Controller.WidgetGenerator.settings.buttonTpl,
      model: {
        target: target,
        interactive: true,
        buttonText: Hafas.Util.HTMLDecode(buttonText),
        primaryClr: Hafas.Config.Styling.ColorSchemes[Hafas.Core.getColorScheme()]['lyr-primary'],
        buttonLink: buttonUrl
      }
    }, Hafas.bind(function (btnCodeRendered) {
      this.Controller.WidgetGenerator.settings.widgetCode = btnCodeRendered.trim();
      this.Controller.WidgetGenerator.calculateCodePreviewHeight();
    }, this));
  },
  calculateCodePreviewHeight: function () {
    var htmlCodeTextArea = Hafas('[data-widgetgenerator="htmlcode"]', false);
    if (htmlCodeTextArea) {
      htmlCodeTextArea.style.height = htmlCodeTextArea.scrollHeight + "px";
    }
  },
  prepareWidgetCode: function (customData) {
    var widgetCodeAsObject = {
      "widget": true
    };

    if (this.Controller.WidgetGenerator.settings.showLogo == false) {
      widgetCodeAsObject['widget-switches-showlogo'] = this.Controller.WidgetGen.showLogo;
    }
    if (Hafas.Config.Switches.useColorTheming) {
      widgetCodeAsObject['widget-cfg-colorscheme'] = this.Controller.WidgetGenerator.settings.color;
    } else {
      widgetCodeAsObject['widget-cfg-colorscheme'] = Hafas.Config.ColorScheme.availableSchemes[0];
    }
    // Build Features
    var features = this.Controller.WidgetGenerator.settings.features;
    for (var w in features) {
      if (features[w].active) {
        var tmpType = w.toLowerCase();
        var tmpData = features[w].data;
        widgetCodeAsObject['widget-' + tmpType] = true;
        for (var d in tmpData) {
          widgetCodeAsObject['widget-' + tmpType + '-' + d] = tmpData[d];
        }
      }
    }
    this.Controller.WidgetGenerator.settings.widgetCode = this.Controller.WidgetGenerator.createWidgetCode(widgetCodeAsObject);
    return widgetCodeAsObject;
  },
  sanitize: function (string) {
    var div = document.createElement('div');
    div.innerHTML = string;
    return div.textContent;
  },
  createWidgetCode: function (widgetCodeAsObject) {
    var widgetCode = document.createElement('div');
    for (var prop in widgetCodeAsObject) {
      var key = this.sanitize(prop);
      var value = this.sanitize(widgetCodeAsObject[prop]);
      try {
        widgetCode.setAttribute('data-hfs-' + key, value);
      }
      catch(e) {}
    }
    return widgetCode.outerHTML;
  },
  updateWidgetPreview: function (refreshWidget) {
    var btnPreview = Hafas('#HFS_WidgetButtonPreview', false);
    var widgetPreview = Hafas('#HFS_WidgetgeneratorPreview', false);
    var widgetPreviewOverlay = Hafas('#HFS_WidgetGeneratorOverlay', false);
    var layout = this.Controller.WidgetGenerator.settings.layout;


    if (layout == 'widget') {
      Hafas.Util.gui.setVisibility(widgetPreview, true);
      Hafas.Util.gui.setVisibility(widgetPreviewOverlay, true);
      Hafas.Util.gui.setVisibility(btnPreview, false);
      if (typeof refreshWidget == 'undefined' || refreshWidget == true) {
        var widgetCodeAsObject = Hafas.bind(this.Controller.WidgetGenerator.prepareWidgetCode, this)();
        var widgetCodeBase64 = Hafas.Util.b64EncodeUnicode(JSON.stringify(widgetCodeAsObject));
        var widgetPreviewUrl = "documentation/preview.html?";
        if (this.Controller.WidgetGenerator.currentTab != null) {
          widgetPreviewUrl += "currentTab=" + this.Controller.WidgetGenerator.currentTab + "&";
        }
        if (this.Controller.WidgetGenerator.settings.lang != null) {
          widgetPreviewUrl += "language=" + this.Controller.WidgetGenerator.settings.lang + "&";
        }
        widgetPreviewUrl += "widgetData=" + widgetCodeBase64;
        if (Hafas.Config.isCustomer == true) {
          widgetPreviewUrl += "&L=" + Hafas.Config.CustomerName + "&";
        }
        var cacheParamValue = (new Date()).getTime();
        widgetPreviewUrl += '&antiCache=' + cacheParamValue;
        Hafas('#HFS_WidgetgeneratorPreview', false).contentWindow.location.replace(widgetPreviewUrl);
      }
    } else if (layout == 'button') {
      Hafas.Util.gui.setVisibility(widgetPreview, false);
      Hafas.Util.gui.setVisibility(widgetPreviewOverlay, false);
      Hafas.Util.gui.setVisibility(btnPreview, true);
      Hafas.bind(this.Controller.WidgetGenerator.prepareButtonCode, this)();

      // We need to remove double-encoded "ampersand" before rendering the preview of the button
      // Only applies when a user used a brackets like "<" or ">" in the text
      var buttonText = this.Controller.WidgetGenerator.settings.widgetCode;
      var buttonPreviewHtml = this.Controller.WidgetGenerator.stripAmpersandEncodingFromButton(buttonText);
      btnPreview.innerHTML = buttonPreviewHtml;
    }
  },
  /**
   * this function removes double encoded ampersands from a button text, this is necessary because the same
   * snippet is used for rendering the "code" area but also the preview which must not have a double ampersand encoding
   * in order to display properly
   *
   * @method stripAmpersandEncodingFromButton
   * @param {String} buttonText Button text for current widget
   *
   * @returns {string} returns the string of the button text without double encoded ampersand,
   *                   so it
   * **/
  stripAmpersandEncodingFromButton: function(buttonText){
    return buttonText.replace(/&amp;lt;/g, '&lt;').replace(/&amp;gt;/g, '&gt;');
  },
  createCode: function () {
    var buttons = this.Controller.WidgetGenerator.mainNavi.getState().buttons;
    // Auf "Code" Panel springen
    this.Controller.WidgetGenerator.mainNavi.setActiveIndex(buttons.length - 1);
    Hafas.bind(this.Controller.WidgetGenerator.changePage, this)("Code");
  },
  copyCode: function () {
    var widgetCodeTextArea = Hafas('[data-widgetgenerator="htmlcode"]', false);
    if (Hafas.Util.isIOSDevice()) {
      var el = document.createElement('textarea');
      el.value = '';
      var copyPasteField = Hafas("#HFS_WidgetgeneratorCopyPasteCode", false);
      if (copyPasteField !== null) {
        el.value = copyPasteField.value;
      }
      el.setAttribute('readonly', '');
      el.style = {position: 'absolute', left: '-9999px'};
      document.body.appendChild(el);

      // save current contentEditable/readOnly status
      var editable = el.contentEditable;
      var readOnly = el.readOnly;

      // convert to editable with readonly to stop iOS keyboard opening
      el.contentEditable = true;
      el.readOnly = true;

      // create a selectable range
      var range = document.createRange();
      range.selectNodeContents(el);

      // select the range
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 999999);

      // restore contentEditable/readOnly to original state
      el.contentEditable = editable;
      el.readOnly = readOnly;
      document.execCommand('copy');
      document.body.removeChild(el);
    } else {
      widgetCodeTextArea.select();
      document.execCommand("copy");
    }
    return false;
  },
  generatorDimensionChanged: function () {
    var webAppW = window.innerWidth;
    if (!Hafas.Config.Switches.useMediaQueries) {
      webAppW = $webappWrap.offsetWidth;
    }
    var $webappWrap = Hafas('#' + this.formContainer, false);
    $webappWrap.className = 'lyr_wrapApplication';


    switch (true) {
      case webAppW > Hafas.Config.UI.layoutClassMinWidths.xLarge:
        $webappWrap.addClassName('layout-xlarge');
        this.layoutClass = 'xlarge';
        break;
      case webAppW > Hafas.Config.UI.layoutClassMinWidths.large:
        $webappWrap.addClassName('layout-large');
        this.layoutClass = 'large';
        break;
      case webAppW > Hafas.Config.UI.layoutClassMinWidths.mid:
        $webappWrap.addClassName('layout-mid');
        this.layoutClass = 'mid';
        break;
      case webAppW > Hafas.Config.UI.layoutClassMinWidths.small:
        $webappWrap.addClassName('layout-small');
        this.layoutClass = 'small';
        break;
    }
  },
  confirmDTP: function (data) {
    Hafas.Modules.TimeDatePicker.getInstanceById(data.pickerId).confirm();
  },
  cancelDTP: function (data) {
    Hafas.Modules.TimeDatePicker.getInstanceById(data.pickerId).cancel();
  },
  goBack: function () {
    Hafas.Modules.History.goBack();
  },
  closeView: function (histData) {

  },
  restoreView: function (histData) {
    var naviState = this.Controller.WidgetGenerator.mainNavi.getState();
    var view = histData.view;
    switch (view) {
      case 'changePage':
        for (var p = 0; p < naviState.panels.length; p++) {
          if (naviState.panels[p].id == 'HFS_Widgetgenerator' + histData.data.pageId) {
            naviState.buttons[p].onclick();
            this.Controller.WidgetGenerator.mainNavi.setActiveIndex(p);
          }
        }
        break;
    }
  },
  toggleAutoSearch: function (boolval, ctx) {
    this.Controller.WidgetGenerator.settings.features[ctx].data.autosearch = boolval;
    Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
  },
  toggleNewTab: function (boolval, ctx) {
    this.Controller.WidgetGenerator.settings.features[ctx].data.postform = (boolval) ? "newtab" : "samepage";
    Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
  },
  TP: {
    selectStart: function (location, suggest) {
      this.Controller.WidgetGenerator.settings.features.TP.data.dep = location.name;
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
    },
    selectDest: function (location, suggest) {
      this.Controller.WidgetGenerator.settings.features.TP.data.arr = location.name;
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
    },
    removeLocation: function (type) {
      var domInput = Hafas('#HFS_WidgetgeneratorTPInput' + type, false);
      domInput.value = '';
      if (type == 'From') {
        delete this.Controller.WidgetGenerator.settings.features.TP.data.dep
      }
      else if (type == 'To') {
        delete this.Controller.WidgetGenerator.settings.features.TP.data.arr
      }
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
    },
    selectDateTime: function (hciDate, hciTime, enquiry, nowMode) {
      if (nowMode == false) {
        this.Controller.WidgetGenerator.settings.features.TP.data.date = hciDate;
        this.Controller.WidgetGenerator.settings.features.TP.data.time = hciTime;
      } else {
        delete this.Controller.WidgetGenerator.settings.features.TP.data.date;
        delete this.Controller.WidgetGenerator.settings.features.TP.data.time;
      }
      this.Controller.WidgetGenerator.settings.features.TP.data.enquiry = enquiry;
      this.Controller.WidgetGenerator.settings.features.TP.data.nowMode = nowMode;
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
    }
  },
  SQ: {
    selectLocation: function (location, suggest) {
      this.Controller.WidgetGenerator.settings.features.SQ.data.location = location.lid;
      this.Controller.WidgetGenerator.settings.features.SQ.data.locationname = location.name;
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
    },
    removeLocation: function () {
      var domInput = Hafas('#HFS_WidgetgeneratorSQInputLocation', false);
      domInput.value = '';
      delete this.Controller.WidgetGenerator.settings.features.SQ.data.location;
      delete this.Controller.WidgetGenerator.settings.features.SQ.data.locationname;
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
    },
    selectDateTime: function (hciDate, hciTime, enquiry, nowMode) {
      if (nowMode == false) {
        this.Controller.WidgetGenerator.settings.features.SQ.data.date = hciDate;
        this.Controller.WidgetGenerator.settings.features.SQ.data.time = hciTime;
        this.Controller.WidgetGenerator.settings.features.SQ.data.enquiry = enquiry;
        this.Controller.WidgetGenerator.settings.features.SQ.data.nowMode = false;
      } else {
        delete this.Controller.WidgetGenerator.settings.features.SQ.data.date;
        delete this.Controller.WidgetGenerator.settings.features.SQ.data.time;
        delete this.Controller.WidgetGenerator.settings.features.SQ.data.enquiry;
        delete this.Controller.WidgetGenerator.settings.features.SQ.data.nowMode;
      }
      Hafas.bind(this.Controller.WidgetGenerator.updateWidgetPreview, this)();
    },
  }
};
